<template>
  <b-field :label="label" expanded>
    <div class="filtro-texto-todos">
      <b-input
        :value="value"
        :placeholder="showTodos ? '' : placeholder"
        class="filtro-texto-todos__control"
        :class="{ 'filtro-texto-todos__control--todos': showTodos }"
        @input="$emit('input', $event)"
        @focus="onFocus"
        @blur="onBlur"
      />
      <span v-if="showTodos" class="filtro-texto-todos__todos" aria-hidden="true">
        <span class="filtro-texto-todos__tag">
          <span class="filtro-texto-todos__tag-label">Todos</span>
        </span>
      </span>
    </div>
  </b-field>
</template>

<script>
export default {
  name: 'FiltroTextoTodos',
  props: {
    label: { type: String, required: true },
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    showTodosTag: { type: Boolean, default: true },
  },
  data() {
    return { focused: false };
  },
  computed: {
    showTodos() {
      return this.showTodosTag && !this.focused && !String(this.value || '').trim();
    },
  },
  methods: {
    onFocus() {
      this.focused = true;
    },
    onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.filtro-texto-todos {
  position: relative;
  width: 100%;
}

.filtro-texto-todos__todos {
  align-items: center;
  bottom: 0;
  display: flex;
  left: 0.75rem;
  pointer-events: none;
  position: absolute;
  right: 0.75rem;
  top: 0;
  z-index: 2;
}

.filtro-texto-todos__tag {
  align-items: center;
  background: #f5f5f5;
  border-radius: 2px;
  color: #363636;
  display: inline-flex;
  font-size: 0.75rem;
  max-width: 100%;
  padding: 0.15rem 0.5rem;
}

.filtro-texto-todos__tag-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filtro-texto-todos__control--todos ::v-deep .input {
  caret-color: #363636;
  color: transparent;
}
</style>
